export function initSearchOverlay() {
    const trigger = document.querySelector('.js-searchOverlayTrigger');
    const overlay = document.querySelector('.js-searchOverlay');
    const closeBtn = document.querySelector('.js-searchOverlayClose');
    const backdrop = document.querySelector('.js-searchOverlayBackdrop');

    if (!trigger || !overlay) return;

    function open() {
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('searchOverlay-is-open');
        const input = overlay.querySelector('input[type="text"], input[type="search"]');
        if (input) setTimeout(() => input.focus(), 150);
    }

    function close() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('searchOverlay-is-open');
    }

    trigger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
}
